import {
  CLIENT_CREATION_KEY_ANALYZE,
  CLIENT_CREATION_KEY_API,
  CLIENT_CREATION_KEY_GRAPHQL,
  CLIENT_CREATION_KEY_REPORTS,
  CLIENT_CREATION_KEY_OPENAI,
  updateClients,
} from "./clients/clientRegister";

import { configApiClient } from "./clients/configApiClient";
import { setLearnAppActivityTTL } from "../state/authStore";
import { v3ApiClient } from "./clients/v3ApiClient";
import { Config } from "@/client/types/Config";
import { checkBuildId } from "@/client/utils/reloadForNewBuild";

const getConfig = async (hostname: string) => {
  const response = await configApiClient.get(`/v3/config`);
  checkBuildId(response.data.buildId);

  updateClients(CLIENT_CREATION_KEY_ANALYZE, response.data.analyzeUrl);
  updateClients(CLIENT_CREATION_KEY_API, response.data.apiUrl);
  updateClients(CLIENT_CREATION_KEY_GRAPHQL, response.data.apiUrl);
  updateClients(CLIENT_CREATION_KEY_REPORTS, response.data.reportsUrl);
  updateClients(CLIENT_CREATION_KEY_OPENAI, response.data.apiUrl);
  setLearnAppActivityTTL(response.data.learnAppActivityTTL);

  return {
    ...response.data,
  };
};

// The signed-in half of the configuration (integration links, hub links, editor settings, the
// full feature flags). Merged over the public config once a session exists.
const getCompanyConfig = async (): Promise<Partial<Config>> => {
  const response = await v3ApiClient.get("config/company");
  return response.data;
};

const ConfigService = {
  getConfig,
  getCompanyConfig,
};

export default ConfigService;
